import axios from 'axios';

export async function syncAll(crm) {
  const {data} = await axios.post(`/api/?entity=groups&action=crmSyncAll&crm=${crm}`);
  return data;
}
